<div [ngClass]="{'hidden-panel': hiddenPanel}">
    <mat-tab-group [@.disabled]="true" tabGroupDrag class="mini-tab" mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="composeStickers($event)">
        <mat-tab>
            <ng-template mat-tab-label>
                <div class="menu-button">
                    <mat-icon>image</mat-icon>
                    {{'general.simple' | transloco}}
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <div class="menu-button">
                    <mat-icon>burst_mode</mat-icon>
                    {{'general.playlist' | transloco}}
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <div class="menu-button">
                    <mat-icon>filter_hdr</mat-icon>
                    {{'general.banner' | transloco}}
                </div>
            </ng-template>
        </mat-tab>
    </mat-tab-group>


    <div fxFlex fxLayoutAlign="center center">

    <div class="hide-gt-sm" style="position: relative; top: 8px; left: 5px;">
      <app-scroll-buttons contentId="stickList"></app-scroll-buttons>
    </div>
  </div>
  <div style="width: 100%; height: 30px">
    <app-video-link videoLink="animationsToolbox" style="position: absolute; right: 10px"></app-video-link>
  </div>
  <div class="content-wrapper"
    id="stickList"
    infinite-scroll
    [scrollWindow]="false"
    [infiniteScrollDistance]="scrollDistance"
    [infiniteScrollThrottle]="throttle"
    (scrolled)="loadMoreStickers()">

    <div cdkDropList
      cdkDropListSortingDisabled
      fxLayout="row wrap" fxLayoutAlign="center center"
      class="drag-panel dragCursor"
      [cdkDropListData]="currentStickers"
      (cdkDropListDropped)="dropSticker($event)">

      @for (mini of currentStickers; track mini) {
        <div cdkDrag class="thumbs" [cdkDragData]="mini" [ngClass]="{'selected': selectedItem === mini}">
          @if (animationViewType === 'banner') {
            <span>
              <mat-icon class="thumbsHide fade-in-image" (click)="previewAnimation(mini)">play_circle_outline</mat-icon>
              <img class="shadow-grow-banner bannerImage" loading="lazy" width="230" height="50" [ngSrc]="'./assets/' + mini.fileName" (click)="addSticker(mini)">
              <!--  <div>{{mini.fileName}}</div> -->
              <!-- <div>{{mini.fileName}}</div>-->
              <div *cdkDragPreview class="drag-preview" [ngStyle]="{'width.px': '230', 'height.px': '50'}">
                <img width="230" height="50" [ngSrc]="'./assets/' + mini.fileName"/>
              </div>
            </span>
          }
          @if (animationViewType !== 'banner') {
            <span>
              <mat-icon class="thumbsHide fade-in-image" (click)="previewAnimation(mini)">play_circle_outline</mat-icon>
              <img class="shadow-grow" loading="lazy" width="115" height="60" [ngSrc]="'./assets/' + mini.fileName" (click)="addSticker(mini)">
              <!--  <div>{{mini.fileName}}</div> -->
              <!-- <div>{{mini.fileName}}</div>-->
              <div *cdkDragPreview class="drag-preview" [ngStyle]="{'width.px': 115, 'height.px': 60}">
                <img width="115" height="60" [ngSrc]="'./assets/' + mini.fileName"/>
              </div>
            </span>
          }
        </div>
      }
    </div>
  </div>
</div>

<ng-template let-modal #downloadModal class="transparentDialog">
  <div mat-dialog-content>
    <br/>
    <br/>
    <br/>
    <div fxLayout="column" fxLayoutAlign="center center">
      <div>
        <app-loading [type]="9" [size]="'40px'"></app-loading>
      </div>
      <div style="margin: 15px;" fxFlex fxLayoutAlign="center center">
        <mat-icon style="margin-right: 10px;">file_download</mat-icon>
        <span>{{ resourceName }}</span>
      </div>
      <button mat-mini-fab color="primary" (click)="onClose()" class="fade-in" style="margin-top: 10px;">
        <mat-icon style="transform: scale(1.2);">close</mat-icon>
      </button>
    </div>
    <br/>
    <br/>
  </div>
</ng-template>
<ng-template let-modal #animationPlayers>
  <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div fxLayout="row wrap" fxLayoutAlign="center center" style="width: 100%">
      <div class="dlg-drag-handle" cdkDragHandle>
        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
          <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
          <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
      </div>
      @if (animationViewType === 'banner') {
        <div class="areaClick" (click)="previewAnimationBanner(selectedItem)">
          <div class="container">
            <div class="overlay1"
              [ngStyle]="{'background': 'url(./assets/' + selectedItem.fileName + ')'}">
              <mat-icon class="customIconSize">play_circle</mat-icon>
            </div>
          </div>
        </div>
      }
      @if (animationViewType !== 'banner') {
        <div class="areaClick" (click)="previewAnimationBanner(selectedItem)">
          <div class="container">
            <div class="overlay2"
              [ngStyle]="{'background': 'url(./assets/' + selectedItem.fileName + ')'}">
              <mat-icon class="previewMoveButton customIconSize">play_circle</mat-icon>
            </div>
          </div>
        </div>
      }
    </div>
    <div style="width: 100%; text-align: center">
      <mat-label> {{'general.preview' | transloco}}</mat-label>
      <br/>
      @if (selectedItem && labelCount > 0 && animationViewType !== 'banner') {
        <div>
          Animation includes {{labelCount}} swappable labels
        </div>
      }
    </div>
  </h1>
  <div mat-dialog-content class="dialog-content">
    @if (loadingData) {
      <div style="margin: 50px;">
        <app-loading [type]="-1" [size]="'50px'"></app-loading>
      </div>
    }

    @if (animationViewType === 'resource' || animationViewType === 'playlist') {
      <div class="table-wrapper">
        @if (!loadingData) {
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef> {{'general.name' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef> {{'general.type' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.type}} </td>
            </ng-container>
            <ng-container matColumnDef="image">
              <th mat-header-cell *matHeaderCellDef> {{'general.image' | transloco}}</th>
              <td mat-cell *matCellDef="let element">
                <img class="swap-preview-image" [src]="element.image">
              </td>
            </ng-container>
            <ng-container matColumnDef="swap">
              <th mat-header-cell *matHeaderCellDef> {{'general.swap' | transloco}}</th>
              <td mat-cell *matCellDef="let element">
                <button mat-raised-button type="button" (click)="openAssociateDialog(element)">
                  {{'general.swap' | transloco}}
                </button>
              </td>
            </ng-container>
            <!-- <ng-container matColumnDef="isPlaylist">
            <th mat-header-cell *matHeaderCellDef> {{'general.playlist' | transloco}}</th>
            <td mat-cell *matCellDef="let element">
              <mat-icon *ngIf="element.isPlaylist">check_circle_outline</mat-icon>
            </td>
          </ng-container> -->
          <ng-container matColumnDef="groupHeader">
            <td colspan="999" mat-cell *matCellDef="let groupBy" class="col-group">
              <mat-icon>menu</mat-icon>
              <span>&nbsp;&nbsp;{{groupBy.groupName}}</span>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr mat-row *matRowDef="let row; columns: ['groupHeader']; when: isGroup"></tr>
        </table>
      }
    </div>
  }
  <div fxFlex fxLayoutAlign="center center" fxLayoutGap="32px">
    <button mat-raised-button color="warn" (click)="importAnimationSticker()">
      <mat-icon>downloading</mat-icon>
      {{'general.import' | transloco}}
    </button>
    <button mat-raised-button color="primary" (click)="onClose()">{{'general.cancel' | transloco}}</button>
  </div>
</div>
</ng-template>
